(() => {
const $3569d9efed9b13d7$var$host = window.location.host;
const $3569d9efed9b13d7$var$isLocalEnv = $3569d9efed9b13d7$var$host.startsWith('127.0.0.1');
const $3569d9efed9b13d7$var$pathName = window.location.pathname == '/' ? '' : window.location.pathname;
const $3569d9efed9b13d7$var$urlParams = window.location.search == '' ? '?' : `${window.location.search}&`;
document.addEventListener("DOMContentLoaded", async ()=>{
    const USstores = [
        'thirdmanrecords.com',
        'tmr-test.myshopify.com'
    ];
    const UKstores = [
        'thirdmanstore.co.uk',
        'test-uk-eu.myshopify.com'
    ];
    const redirectModal = new bootstrap.Modal(document.getElementById('geoRedirect'));
    const shopCountry = USstores.includes($3569d9efed9b13d7$var$host) ? 'US' : 'UK';
    //console.log('shopCountry', shopCountry);
    const geolocationData = await $3569d9efed9b13d7$var$getGeolocationData();
    //console.log('geolocationData', geolocationData);
    const continentCode = geolocationData?.continent_code;
    //console.log('continentCode', continentCode);
    if (continentCode == 'EU' && shopCountry == 'US' || continentCode == 'NA' && shopCountry == 'UK' && !$3569d9efed9b13d7$var$isLocalEnv) {
        $3569d9efed9b13d7$var$populateModal(geolocationData);
        redirectModal.show();
    }
});
async function $3569d9efed9b13d7$var$getGeolocationData() {
    const url = "https://api.ipstack.com/check?access_key=2b0a9a12377df1aaa8b1531b010d67f4";
    const options = {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    };
    try {
        const response = await fetch(url, options);
        if (!response.ok) throw new Error(`Response status: ${response.status}`);
        const result = await response.json();
        return result;
    } catch (error) {
        console.log('Error fetching geolocation data.');
        console.error(error.message);
    }
}
async function $3569d9efed9b13d7$var$populateModal(geolocationData) {
    const redirectCountryLabel = document.getElementById('geoRedirectCountry');
    const countryName = geolocationData.country_name;
    redirectCountryLabel.innerHTML = countryName;
    const countryCode = geolocationData.country_code;
    const continentCode = geolocationData.continent_code;
    const geoRedirectContinue = document.getElementById('geoRedirectContinue');
    const regionSelect = document.getElementById('regionSelect');
    if (countryCode == 'GB') {
        regionSelect.value = countryCode;
        const selectedOption = regionSelect.options[regionSelect.selectedIndex];
        geoRedirectContinue.href = `https://thirdmanstore.co.uk${$3569d9efed9b13d7$var$pathName}${$3569d9efed9b13d7$var$urlParams}currency=GBP&redirect=true`;
    } else if (continentCode == 'EU' && countryCode !== 'GB') {
        regionSelect.value = continentCode;
        const selectedOption = regionSelect.options[regionSelect.selectedIndex];
        geoRedirectContinue.href = `https://thirdmanstore.co.uk${$3569d9efed9b13d7$var$pathName}${$3569d9efed9b13d7$var$urlParams}currency=EUR&redirect=true`;
    } else {
        regionSelect.value = 'US';
        const selectedOption = regionSelect.options[regionSelect.selectedIndex];
        geoRedirectContinue.href = `https://thirdmanrecords.com${$3569d9efed9b13d7$var$pathName}${$3569d9efed9b13d7$var$urlParams}redirect=true`;
    }
    regionSelect.addEventListener("change", (e)=>{
        const selectedOption = e.target.options[e.target.selectedIndex];
        $3569d9efed9b13d7$var$setRegionAndCurrency(selectedOption);
    });
}
function $3569d9efed9b13d7$var$setRegionAndCurrency(selectedOption) {
    const selectedRegionCode = selectedOption.value;
    const selectedCurrency = selectedOption.dataset.currency;
    const geoRedirectContinue = document.getElementById('geoRedirectContinue');
    if (selectedRegionCode == "US") geoRedirectContinue.href = `https://thirdmanrecords.com${$3569d9efed9b13d7$var$pathName}${$3569d9efed9b13d7$var$urlParams}redirect=true`;
    else geoRedirectContinue.href = `https://thirdmanstore.co.uk${$3569d9efed9b13d7$var$pathName}${$3569d9efed9b13d7$var$urlParams}redirect=true&currency=${selectedCurrency}`;
}

})();
//# sourceMappingURL=geo-redirects.js.map
